<template>
  <div class='EstoqueVariavel'>
    <div style="width: 8%">
      <img v-if="data.img.length" :src="api + data.img[0].img">
      <img-icon v-if="!data.img.length" />
    </div>
    <div class="c-name">{{ data.name }}</div>
    <div class="c-status mobile-none">
      <div v-if="data.status" class="pub">Publicado</div>
      <div v-if="!data.status" class="arq">Arquivado</div>
    </div>
    <div v-if="data.tipo !== 'Variável'" class="c-estoque">{{ data.estoque > 0 ? data.estoque : data.statusEstoque }}</div>
    <div v-if="data.tipo === 'Variável'" class="c-estoque">{{ data.estoqueVariavel.map(e => parseInt(e.src.quantidade)).reduce((c, a) => c + a, 0) }}</div>
    <div class="mobile-none c-preco">
      <span :class="{ disabled: isString(data.oferta) > 0 }" style="display: block">{{ data.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
      <span v-if="isString(data.oferta) > 0" style="display: block; color: #20c997">{{ data.oferta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</span>
    </div>
    <div style="width: 10%" class="mobile-none">{{ JSON.parse(data.categoria)[0] }}</div>
    <div style="width: 4%" class="mobile-none">
      <box-icon
      :options="{ width: '13px', height: '13px' }"
      :text="data.tipo"
      :active="true"
      />
    </div>
    <div style="width: 4%" class="mobile-none">
      {{ data.visualizacao }}
    </div>
    <div style="width: 10%" class="mobile-none">{{ data.dateCreate }}</div>
  </div>
</template>

<script>
import BoxIcon from '../Icons/BoxIcon.vue'
import ImgIcon from '../Icons/ImgIcon.vue'
import api from '@/mixins/api'
export default {
  name: 'EstoqueVariavel',
  props: ['data'],
  components: { BoxIcon, ImgIcon },
  mixins: [api],
  methods: {
    isString (value) {
      return typeof value === 'string' ? parseFloat(value.replace(/\./g, '').replace('R$ ', '').replace(',', '.')) : value
    }
  }
}
</script>

<style scoped>
.EstoqueVariavel {
  height: 10%;
  display: flex;
  align-items: center;
}

img {
  width: 30px;
  height: 30px;
}

.pub {
  width: 80%;
  margin: auto;
  background-color: #20c997;
  color: #FFFFFF;
  padding: 3px;
  font-size: 12px;
  border-radius: 3px;
}

.arq {
  width: 80%;
  margin: auto;
  background-color: #f86c6b;
  color: #FFFFFF;
  padding: 3px;
  font-size: 12px;
  border-radius: 3px;
}

.disabled {
  color: red;
  text-decoration: line-through;
}

.c-name {
  width: 35%;
  text-align: left;
}

.c-status {
  width: 8%;
}

.c-preco {
  width: 8%;
}

.c-estoque {
  width: 10%;
}

@media (max-width: 500px) {
  .mobile-none {
    display: none;
  }
  .c-name {
    width: 70%;
  }
  .c-status {
    width: 20%;
  }
  .c-preco {
    width: 20%;
  }
  .c-estoque {
    width: 20%;
    text-align: right;
  }
}
</style>
